export const lightBrown = "#cda57a";
export const worldfengurGreen = "#768453";
export const primaryBrown = "#332723";
export const darkBrown = "#5B3927";
export const intensitySliderBrown = "#96481F";
export const restDayBlue = "#486581";
